import request from '@/utils/request'

// 兑奖商品卡列表
export const listGoodsCards = (pageData, formData) => {
    return request.get(`/goods-cards/${pageData.page}/${pageData.pageSize}`, {params:formData})
}

// 兑奖商品卡详情
export const detailGoodsCards = (goodsId) => {
    return request.get(`/goods-cards/${goodsId}`)
}
